import React from 'react';
import { MenuItem, IconButton, Menu, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';
import { iconButtonSx } from '../../UI/iconButtonSx';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState(null);

    return (
        <>
            <IconButton sx={iconButtonSx} onClick={(e) => setAnchorEl(e.currentTarget)}>
                <LanguageIcon />
            </IconButton>

            <Menu 
                anchorEl={anchorEl} 
                open={Boolean(anchorEl)} 
                onClose={() => setAnchorEl(null)}
                PaperProps={{
                    sx: {
                        backgroundColor: theme.palette.background.paper,
                        border: `1px solid ${theme.palette.divider}`,
                    }
                }}
            >
                <MenuItem 
                    onClick={() => { i18n.changeLanguage('en'); setAnchorEl(null); }}
                    sx={{
                        color: theme.palette.text.primary,
                        '&:hover': {
                            backgroundColor: theme.palette.action.hover,
                        },
                    }}
                >
                    English
                </MenuItem>
                <MenuItem 
                    onClick={() => { i18n.changeLanguage('ar'); setAnchorEl(null); }}
                    sx={{
                        color: theme.palette.text.primary,
                        '&:hover': {
                            backgroundColor: theme.palette.action.hover,
                        },
                    }}
                >
                    العربية
                </MenuItem>
            </Menu>
        </>
    );
};

export default LanguageSwitcher;
